import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const VisionMissionPage = lazy(() => import('../pages/vision-mission/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProductionQualityPage = lazy(() => import('../pages/production-quality/page'));
const SustainabilityPage = lazy(() => import('../pages/sustainability/page'));
const HumanResourcesPage = lazy(() => import('../pages/human-resources/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/vision-mission',
    element: <VisionMissionPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/production-quality',
    element: <ProductionQualityPage />,
  },
  {
    path: '/sustainability',
    element: <SustainabilityPage />,
  },
  {
    path: '/human-resources',
    element: <HumanResourcesPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/quote',
    element: <QuotePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
